import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { qr } from '../api';

const DownloadPage = () => {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    qr.getDownloads(token)
      .then((res) => setData(res.data))
      .catch(() => setError('Ugyldig eller utløpt QR-kode'))
      .finally(() => setLoading(false));
  }, [token]);

  const handleDownload = (presentation) => {
    const url = `https://podium.botcenter.app/uploads/${presentation.conference_id}/${presentation.filename}`;
    const link = document.createElement('a');
    link.href = url;
    link.download = presentation.original_filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  if (loading) return (
    <div className="flex items-center justify-center h-screen bg-cream-50">
      <p className="text-navy-400">Laster...</p>
    </div>
  );

  if (error) return (
    <div className="flex items-center justify-center h-screen bg-cream-50">
      <p className="text-red-500">{error}</p>
    </div>
  );

  const downloadList = data.presentations.filter((p) => p.type === 'presentation' || p.type === null);

  return (
    <div className="min-h-screen bg-cream-50">
      <div className="bg-navy-800 text-white px-5 py-6">
        <div className="max-w-lg mx-auto">
          <p className="text-gold-400 text-xs font-semibold uppercase tracking-widest mb-1">PODIUM</p>
          <h1 className="text-2xl font-bold text-cream-100">Last ned presentasjoner</h1>
          <p className="text-navy-300 mt-1 text-sm">Velg presentasjonene du vil laste ned</p>
        </div>
      </div>

      <div className="max-w-lg mx-auto px-4 py-5">
        {downloadList.length === 0 ? (
          <div className="bg-white rounded-xl shadow-sm p-8 text-center">
            <p className="text-4xl mb-3">📂</p>
            <p className="text-navy-600 font-medium">Ingen presentasjoner tilgjengelig</p>
          </div>
        ) : (
          <div className="grid gap-3">
            {downloadList.map((p) => (
              <div key={p.id} className="bg-white rounded-xl shadow-sm p-4 border-l-4 border-navy-700 flex justify-between items-center">
                <div className="flex gap-3 items-center">
                  <span className="text-xl">🎤</span>
                  <div>
                    <p className="font-semibold text-navy-800">{p.title}</p>
                    <p className="text-sm text-navy-500">
                      {p.speaker_name}{p.speaker_organization && ` · ${p.speaker_organization}`}
                    </p>
                    <span className="text-xs bg-navy-100 text-navy-600 px-2 py-0.5 rounded-lg uppercase font-medium mt-1 inline-block">
                      {p.file_type?.replace('.', '') || 'fil'}
                    </span>
                  </div>
                </div>
                <button onClick={() => handleDownload(p)}
                  className="shrink-0 bg-navy-700 text-white px-4 py-2 rounded-lg hover:bg-navy-800 transition font-medium text-sm">
                  Last ned
                </button>
              </div>
            ))}
          </div>
        )}
        <p className="text-center text-xs text-navy-300 mt-8 tracking-wide">PODIUM · Konferanseverktøy</p>
      </div>
    </div>
  );
};

export default DownloadPage;
